// AUTO-GENERATED — do not edit by hand.
// Derived from `.browserslistrc`
// Run `npm run generate:browser-support` to regenerate (also done in CI).

export const MIN_SUPPORTED_BROWSERS: Record<string, string> = {
    chrome: '>=124',
    edge: '>=124',
    firefox: '>=125',
    safari: '>=17.5',
};
